import { Phone, MessageCircle } from "lucide-react";
import { waLink, telLink } from "@/config/site";

// Fixed floating actions — WhatsApp + Click-to-Call. Visible on all devices.
export function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp"
        className="group flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg shadow-black/20 transition-transform duration-200 hover:-translate-y-1"
      >
        <MessageCircle className="h-7 w-7 text-white" />
      </a>
      <a
        href={telLink}
        aria-label="Call BNZ Solutions"
        data-testid="floating-call"
        className="group flex h-14 w-14 items-center justify-center rounded-full bg-navy shadow-lg shadow-black/20 transition-transform duration-200 hover:-translate-y-1"
      >
        <Phone className="h-6 w-6 text-gold" />
      </a>
    </div>
  );
}
